import { FC } from 'react'

import clsx from 'clsx'

import { defaultBorder, errorBorder } from 'shared/constants'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { Paper } from '../paper'

import s from './styles.module.scss'

interface Props {
  icon?: AllIcons
  rightIcon?: AllIcons
  value?: string
  placeholder?: string
  onClick?: () => void
  radius?: number
  error?: boolean
  height?: 'auto' | '100%'
  type?: 'white' | 'grey' | 'lightGrey'
  iconPlace?: 'left' | 'right'
  isBlackIcon?: boolean
  isEllipsis?: boolean
}

//text-overflow: ellipsis;

export const ButtonIconText: FC<Props> = ({
  icon,
  rightIcon,
  value,
  placeholder,
  error,
  radius,
  onClick,
  type = 'grey',
  height = 'auto',
  iconPlace = 'left',
  isBlackIcon,
  isEllipsis,
}) => {
  return (
    <Paper
      type={type}
      padding={[0, 16]}
      radius={radius || 12}
      height={height}
      border={error ? errorBorder : defaultBorder}
    >
      <button
        type="button"
        onClick={onClick}
        className={s.container}
      >
        {icon && iconPlace === 'left' ? (
          <AppIcon
            id={icon}
            className={clsx(s.icon, error && s.iconError)}
          />
        ) : null}
        <div
          className={clsx({
            [s.value]: !!value?.length,
            [s.valueRed]: error,
            [s.isEllipsis]: isEllipsis,
          })}
        >
          {value?.length ? (
            <div className={s.box}>
              <span className={clsx(s.label, 'medium-12')}> {placeholder}</span>
              {value}
            </div>
          ) : (
            <span className={s.placeholder}>{placeholder}</span>
          )}
        </div>

        {rightIcon ? (
          <AppIcon
            id={rightIcon}
            className={clsx(
              s.rightIcon,
              error && s.iconError,
              isBlackIcon && s.blackIcon,
            )}
            width={24}
            height={24}
          />
        ) : null}
      </button>
    </Paper>
  )
}
